module.exports = __webpack_public_path__ + "static/artwork-our-vision-background-d2ba10dd069ee029f97c2c56e0928df6.svg";